import { toSafeString } from '@shared/utils';

const normalizeRoleRecord = (role = {}) => {
  const companyId = toSafeString(role?.companyId || role?.company_id) || null;

  return {
    id: toSafeString(role?.id),
    name: toSafeString(role?.name),
    description: toSafeString(role?.description) || null,
    companyId,
    isBuiltIn: !companyId || companyId === 'MINDCLOUD'
  };
};

export default normalizeRoleRecord;
